import { useState } from "react";
import "./ParentLoginForm.css";
import { useRouteMatch, Link, useHistory } from "react-router-dom";
import axios from "axios";
import loadingImage from "../../assets/images/loading2.gif";
import Swal from "sweetalert2";

const ParentLoginForm = () => {
  const history = useHistory();
  let { url } = useRouteMatch();

  const [user, setUser] = useState({ code: "", id: "" });
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();

    setErrors(null);
    try {
      setLoading(true);
      const loginResponse = await axios.post("/api/parents/login", user);
      const token = loginResponse.headers["x-auth-token"];
      localStorage.setItem("token", token);
      localStorage.setItem("firstName", loginResponse.data.data[0].PrivateName);
      history.replace(loginResponse.data.path);
    } catch (error) {
      if (error.response) {
        if (error.response.data.fields) {
          setErrors(error.response.data.fields);
        } else if (error.response.data.message) {
          Swal.fire({
            title: "שגיאה",
            text: `${error.response.data.message}`,
            icon: "error",
            confirmButtonText: "סגירה",
          });
        } else {
          console.error(error.response.data);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const onInputChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  return (
    <div id="main2">
      <form id="parentLoginForm" onSubmit={login}>
        <h2>כניסת הורים</h2>
        <div className="inputDiv">
          <input
            className="input"
            onChange={onInputChange}
            type="text"
            value={user.code}
            name="code"
            id="code"
            placeholder="קוד חווה"
          />
          <span>{errors && errors.code ? errors.code : ""}</span>
        </div>
        <div className="inputDiv">
          <input
            className="input"
            onChange={onInputChange}
            type="password"
            value={user.id}
            name="id"
            id="id"
            placeholder="ת.ז."
          />
          <span>{errors && errors.id ? errors.id : ""}</span>
        </div>
        <div>
          <button id="submit">כניסה</button>
        </div>
      </form>
      <div id="parentLogin">
        <Link to={`/login`}>למעבר לכניסת צוות</Link>
      </div>
      {loading && (
        <div id="loading">
          <img src={loadingImage} alt="loading..." />
        </div>
      )}
    </div>
  );
};

export default ParentLoginForm;
